import {getContext, getElement, store} from '@wordpress/interactivity';

store('wpbs/review-content', {
    actions: {
        toggle() {
            const el = getElement()?.ref ?? null;

            if (!el) return;

            const parent = el.closest('.loop-card, .wpbs-slide');

            if (!parent) return;

            const card = parent.cloneNode(true);

            card.style.height = 'auto';
            card.style.width = '100%';
            card.style.margin = 'auto';

            card.classList.add('wpbs-review-card');

            WPBS.modals.toggle_modal(false, {
                template: card
            });

        },
    },
});